import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Change,
  Reset,
} from "../../../store/async-actions/digitalmarketing/header";
import {
  useGetDashboardCustomersQuery,
  useGetDashboardStatusesQuery,
} from "../../../Service/dashboard";
import Pagination from "../../../Component/DigitalMarketing/Pagination";
import DashTable from "./DashTable";
import DashTabs from "./DashTabs";
import { Col, Row } from "react-bootstrap";
import SearchBox from "../../../Component/DigitalMarketing/SearchBox";
import NewDateRangePicker from "../../../Component/DigitalMarketing/Forms/NewDateRangePicker";
import Dropdown from "../../../Component/DigitalMarketing/Forms/Dropdown";
import { Button } from "@mui/material";
import moment from "moment";
import { Source } from "../Reports/Utils/TableHeadlist";
import { FiFilter } from "react-icons/fi";
import DialogModal from "../../../Component/DigitalMarketing/DialogModal";
import { LeadBulkuploadForm } from "./Utils/TableHeadlist";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import Toast from "../../../Component/DigitalMarketing/Toast";
import { useAddBulkCustomerMutation } from "../../../Service/customers";
import Loader from "../../../Component/DigitalMarketing/Loader";
import { useGetAllBranchesQuery } from "../../../Service/Masters";

function Database({ setUpdateData, setShowAddType, showAddType }) {
  const [pagination, setpagination] = useState(1);
  const [lead, setLeads] = useState<any>({});
  const [filter, setFilter] = useState("");
  const [branchId, setBranchId] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [show, setShow] = useState(false);
  const [source, setSource] = useState("");

  const initialstate = {
    startDate: null,
    endDate: null,
  };
  const [date, setDate] = useState(initialstate);
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    null,
    null,
  ]);

  const [paramsValue, setParamsValue] = useState({
    date: initialstate,
    source: "",
  });

  const dispatch = useDispatch<any>();
  const getStatus = useGetDashboardStatusesQuery();
  const [open, setOpen] = useState(false);
  const { open: open1, message, openSnackBar, type } = useSnackbar();
  const account = useSelector((state: any) => state.auth);
  const { roleName } = account;
  const { data: branchOptions } = useGetAllBranchesQuery({
    refetchOnMountOrArgChange: true,
  });

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setLeads({});
  };

  const onChangeSearch = (event) => {
    setSearchValue(event.target.value);
  };

  const pagi = {
    pageNo: pagination,
    date: paramsValue?.date,
    filter: filter,
    source: paramsValue?.source,
    name: searchValue,
    branchId: branchId,
  };

  useEffect(() => {
    setpagination(1);
  }, [filter, searchValue]);

  const { data: Leadslist, isLoading }: any = useGetDashboardCustomersQuery(
    pagi,
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const [addBulkCustomer] = useAddBulkCustomerMutation();

  // ✅ Filter only for source
  const ListFilter = () => {
    setParamsValue((prev) => ({
      ...prev,
      source,
    }));
    setShow(true);
    setpagination(1);
  };

  useEffect(() => {
    dispatch(Reset());
  }, [dispatch]);

  const onFilter = (value) => {
    if (value === "All") {
      setFilter("");
    } else {
      setFilter(value);
    }
  };

  useEffect(() => {
    const data: any = {
      first: "Lead Management",
    };
    dispatch(Change(data));
  }, [dispatch]);

  // ✅ DateRange auto filter (no Filter button needed)
  const onHandleChange = (event) => {
    const { name, value } = event.target;
    if (name === "date") {
      const [start, end] = value;
      const updatedDate = {
        startDate: start ? moment(start).format("YYYY-MM-DD") : null,
        endDate: end ? moment(end).format("YYYY-MM-DD") : null,
      };
      setDate(updatedDate);
      setDateRange(value);

      // Auto apply filter only when both dates selected
      if (updatedDate.startDate && updatedDate.endDate) {
        setParamsValue((prev) => ({
          ...prev,
          date: updatedDate,
        }));
        setShow(true);
        setpagination(1);
      }
    } else if (name === "source") {
      setSource(value);
    }
  };

  const ClearFilter = () => {
    setShow(false);
    setDate(initialstate);
    setDateRange([null, null]);
    setParamsValue({ date: initialstate, source: "" });
    setSource("");
    setSearchValue("");
  };

  const OnChange = (event) => {
    const { name, files } = event.target;
    setLeads((prevState) => ({ ...prevState, [name]: files[0] }));
  };

  const onSubmit = async () => {
    let data: any = { ...lead };
    var form_data = new FormData();
    for (var key in data) {
      form_data.append(key, data[key]);
    }
    if (lead?.file) {
      try {
        await addBulkCustomer(form_data).unwrap();
        openSnackBar("Added successfully");
        handleClose();
      } catch (error: any) {
        openSnackBar(error.data.error, "error");
      }
    } else {
      openSnackBar("Please fill all data before submit!", "error");
    }
  };

  if (isLoading) {
    return <Loader loading={true} />;
  }

  return (
    <React.Fragment>
      <div>
        <Toast open={open1} type={type} message={message} />

        <DialogModal
          title="Upload Leads"
          formlist={LeadBulkuploadForm}
          open={open}
          download={true}
          handleChange={OnChange}
          handleSubmit={onSubmit}
          handleClose={handleClose}
        />

        <Row className="align-items-center mb-3 g-2">
          {/* 🔍 Search on the left */}
          <Col xs={12} md={3}>
            <SearchBox
              value={searchValue}
              onChange={(event) => onChangeSearch(event)}
            />
          </Col>

          {/* 🔽 Filters grouped on right */}
          <Col
            xs={12}
            md={9}
            className="d-flex align-items-center justify-content-end flex-wrap gap-2"
          >
            {roleName === "super_admin" && (
              <div style={{ minWidth: "180px" }}>
                <select
                  className="form-select"
                  name="branchId"
                  value={branchId}
                  onChange={(e) => setBranchId(e.target.value)}
                >
                  <option value="">Filter Branch</option>
                  {branchOptions?.data?.map((branch) => (
                    <option key={branch.id} value={branch.id}>
                      {branch.branchName}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {/* 📅 Auto Filter on Date Change */}
            <div style={{ minWidth: "200px" }}>
              <NewDateRangePicker
                value={dateRange}
                onChange={(dates) =>
                  onHandleChange({ target: { name: "date", value: dates } })
                }
              />
            </div>

            {/* 🧭 Source Filter with button */}
            <div style={{ minWidth: "180px" }}>
              <Dropdown
                option={Source}
                ids="id"
                source={source}
                defaults="Choose Source..."
                list_name="name"
                key_name="source"
                handleChange={onHandleChange}
              />
            </div>

            <div className="d-flex align-items-center">
              <Button
                variant="contained"
                onClick={ListFilter}
                id="btn-add"
                className="me-2"
              >
                <FiFilter /> &nbsp; Filter
              </Button>

              {show && (
                <p
                  className="clear-filter f-14 mb-0 mt-1 cursor text-danger fw-semibold"
                  onClick={ClearFilter}
                >
                  X Clear
                </p>
              )}
            </div>
          </Col>
        </Row>

        <DashTabs
          handleOpen={handleOpen}
          onFilter={onFilter}
          showAddType={showAddType}
          setShowAddType={setShowAddType}
        />

        <DashTable
          customer={Leadslist}
          isLoading={isLoading}
          setUpdateData={setUpdateData}
        />

        {!isLoading && (
          <Pagination
            setpagination={setpagination}
            pagination={pagination}
            data={Leadslist}
          />
        )}
      </div>
    </React.Fragment>
  );
}

export default React.memo(Database);
